export default __webpack_public_path__ + "static/media/studio.82dffca2.svg";